export default [
  {
    typ: "deckungssumme",
    titel: "Deckungssumme",
    produktLinien: ["001", "002", "003"],
    selectname: "deckungssumme",
    selectoptionen: [
      { label: "10 Mio. €", value: 100 },
      { label: "20 Mio. €", value: 200 },
      { label: "50 Mio. €", value: 500 },
      {label: "100 Mio. €", value: 1000},
    ],
  },
  {
    typ: "selbstbeteiligung",
    titel: "Selbstbeteiligung je Schadenfall",
    produktLinien: ["001", "002", "003"],
    selectname: "selbstbeteiligung",
    selectoptionen: [
      { label: "Keine", value: 0 },
      { label: "150 €", value: 150 },
      { label: "250 €", value: 250 },
    ],
  },
  {
    typ: "anzahlvorschaeden",
    titel: "Anzahl Vorschäden",
    titelMakler: "Anzahl Vorschäden der letzten 5 Jahre",
    produktLinien: ["001", "002", "003"],
    selectname: "anzahlvorschaeden",
    selectoptionen: [
      { label: "Bitte wählen", value: -1 },
      { label: "0", value: 0 },
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
      { label: "4", value: 4 },
      { label: "5 und mehr", value: 5 },
    ],
    infoItem: {
      name: "tariffNumberOfPredamages",
      titel: "Anzahl Vorschäden",
      text: "Anzahl der Vorschäden in den letzten 5 Jahren.",
    },
    zeigeInfoItemMakler: false,
  },
];
